<template>
        <router-link
            :to="{ name: 'project.view', params: { id: project.id, slug: project.slug } }"
            class="border-t last:border-b border-black block"
        >
            <div ref="moleculeCardEvent">
                <!-- MOBILE -->
                <div class="p-4 space-y-10 md:hidden">
                    <div class="flex items-">
                        <div class="text-2xl">
                            {{ project.title }}
                        </div>
                    </div>

                    <div class="flex items-top justify-between">
                        <div class="flex flex-col justify-between">
                            <div class="flex flex-wrap gap-2 h-fit">
                                <div
                                    v-for="type in project.types" :key="type.id"
                                    class="border border-black px-2 py-1 rounded-lg"
                                >
                                    {{ type.name }}
                                </div>
                            </div>
                            <div>
                            </div>
                        </div>

                        <img class="w-28 h-28 rounded-md shrink-0 object-cover" :src="project.cover.cached_url" alt="">
                    </div>

                    <p class="line-clamp-3" v-html="project.presentation"></p>
                </div>
                <!-- END MOBILE -->

                <!-- DESKTOP -->
                <div class="hidden md:flex hover:bg-pink group hover:!text-white transition duration-200 ease-in-out hover:cursor-pointer">
                    <div class="border-r border-black w-1/3">
                        <div class="flex justify-between px-4 lg:px-12 py-6 h-full">
                            <img class="w-28 h-28 rounded-md shrink-0 object-cover aspect-square" :src="project.cover.cached_url" alt="">
                            <div class="text-3xl text-right"></div>
                        </div>
                    </div>
                    <div class="w-2/3">
                        <div class="px-4 lg:px-12 py-6">
                            <div class="flex justify-between">
                                <div class="text-2xl w-1/2 pr-12 shrink-0">
                                    {{ project.title }}
                                </div>
                                <div>
                                    <p class="line-clamp-5" v-html="project.presentation"></p>
                                </div>
                            </div>
                            <div class="flex flex-wrap h-fit mt-2 items-center mt-4">
                                <div class="w-1/2 flex flex-wrap gap-2 pr-4">
                                    <div
                                        v-for="type in project.types" :key="type.id"
                                        v-if="type.name"
                                        class="border border-black group-hover:border-white px-2 py-1 rounded-lg w-fit"
                                    >
                                        {{ type.name }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- END DESKTOP -->
            </div>
        </router-link>
</template>

<script>

export default {
    name: 'MoleculeCardProject',
    props: {
        project: null,
    },
}
</script>
